
































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import SelectGroup from '@/components/Common/SelectGroup.vue';
import { AppModule } from '@/store/modules/app';
import { isMobile } from '@/utils/validate';

import {
  getUserApi,
  getAllAreaCountryListApi,
  getByCountryIdApi,
  getByFkAreaStateIdApi
} from '@/api/login';
import {
  getIssueMajorLevelListApi
} from '@/api/index';
import {
  mpsDatasApi,
  mpsInstitutionGroupDatasApi,
  mpsInstitutionTypeDatasApi,
  mpsInstitutionListApi,
  mpsTopCountriesDatasApi,
  mpsSchoolNationalityListApi,
  mpsContractNationalityListApi,
  mpsSaveInstitutionClick,
  mpsExportExcelApi,
  mpsLevelExportExcelApi
} from '@/api/mps';
import SearchGroup from '@/components/Common/SearchGroup.vue';

interface PaginationFilter<T = any> {
  totalSchool: number,
  totalResult: number,
  currentPage: number,
  showCount: number,
  totalPage: number
}


@Component({
  name: "pmsIndex",
  components: {
    SelectGroup,
    SearchGroup
  },
})
export default class extends Vue {
  public displayOption = 'general';
  public selectCountry = '';
  public selectCountryId = -100;
  public loading = false;

  public schoolName: any = "";
  public countryId = "";
  public stateId = "";
  public cityId = "";
  public majorLevel = "";
  public institutionGroup = "";
  public company = undefined;
  public schoolTypes: any = [];
  public contractNationalityId = '';
  public rule = "";
  public searchKeyword = "";
  public displayLevel = false;
  public displayColumns = [
    { value: 1, label: "本预", labelChn: "本预"},
    { value: 2, label: "International Year 1", labelChn: "国际大一"  },
    { value: 3, label: "Pre-master", labelChn: "硕预" },
    { value: 4, label: "UG", labelChn: "UG" },
    { value: 5, label: "PGT", labelChn: "PGT" },
    { value: 6, label: "PGR", labelChn: "PGR" },
    { value: 7, label: "PHD", labelChn: "PHD" },
    { value: 9, label: "PSE", labelChn: "PSE" },
    { value: 10, label: "Remark", labelChn: "备注" },
    { value: 11, label: "Additional rewards", labelChn: "额外奖励" },
  ];
  public ruleSelect = [
    { value: 1, label: "Foundation" },
    { value: 2, label: "转代理" },
    { value: 3, label: "Foundation + BA" },
  ];
  public schoolOptions: any = [];
  public schoolCountryOptions: any = [];
  public countryOptionsOrg: any = [];
  public countryOptions: any = [];
  public stateOptions: any = [];
  public cityOptions: any = [];
  public fkMajorLevelOptions: any = [];
  public institutionGroupOptions: any = [];
  public institutionTypeOptions: any = [];
  public summaryList: any = [];
  public mpsData: any = [];
  public searchHot = 30;
  public searchNew = 30;
  public selectAllItem: boolean = true;
  public isDisableSearchFilterHot: boolean = false;
  public isDisableSearchFilter: boolean = false;
  public userInfo: any = null;
  public dataPagination: PaginationFilter<any> = {
    totalSchool: 0,
    totalResult: 0,
    currentPage: 1,
    showCount: 10,
    totalPage: 1
  };
  public mpsMode1 = false;
  public mpsMode2 = false;
  public mpsMode3 = false;

  public showCityTips = false;
  public showProvinceTips = false;

  get isMobile() {
      return isMobile();
  }
  get language() {
    return AppModule.language;
  }
  get langEN() {
    if (AppModule.language === 'en-us') {
      return true;
    } else {
      return false;
    }
  }
  public getCountryImageUrl(id: number) {
    try {
      return require('@/assets/image/mps/country_' + (id) + '.png');
    } catch(err) {
      return '';
    }
  }

  public created() {
      this.getUserInfo();
      this.getSummaryList();
  }
  public mounted() {
    this.getSchoolNationalityList();
    this.getAllAreaCountryList();
    this.getIssueMajorLevelList();
    this.getMPSInstitutionGroupList();
    this.getMPSInstitutionTypeList();
    this.getMPSInstitutionList();

    this.getSummaryList();
    this.handleSearch();
  }
  public get isHK() {
    if (this.userInfo) {
      if (this.userInfo.company === "6") {
        return true;
      }
    }
    return false;
  }
  public get isTW() {
    if (this.userInfo) {
      if (this.userInfo.company === "4") {
        return true;
      }
    }
    return false;
  }
  public async getUserInfo() {
    const { data } = await getUserApi();
    this.userInfo = data.data;
    // this.contractNationalityId = 3;
    // if (this.userInfo.company === "6") {//HK
    //   this.contractNationalityId = 9;
    // }
    // if (this.userInfo.company === "4") {//Taiwan
    //   this.contractNationalityId = 33;
    // }
    // if (this.userInfo.company === "15") {//Japan
    //   this.contractNationalityId = 12;
    // }
    // if (this.userInfo.company === "16") {//Korea
    //   this.contractNationalityId = 13;
    // }
    // if (this.userInfo.company === "13") { //Canada
    //   this.contractNationalityId = 3;
    // }
    // if (this.userInfo.company === "14") { //New Zealand
    //   this.contractNationalityId = 3;
    // }
    let modeFound: any[] = [];
    this.mpsMode1 = false;
    this.mpsMode2 = false;
    this.mpsMode3 = false;
    // 暂时取消内部账号路由权限判断
    // if (this.userInfo.issueInnerAccount === true) {
    //   this.mpsMode1 = true;
    //   this.mpsMode2 = true;
    //   this.mpsMode3 = true;
    // } else {
      if (this.userInfo.resourceKeys) {
        if (this.userInfo.resourceKeys.includes('mpsMode5')) {
          this.mpsMode1 = true;
        }
        if (this.userInfo.resourceKeys.includes('mpsMode4')) {
          this.mpsMode2 = true;
        }
        if (this.userInfo.resourceKeys.includes('mpsMode5')) {
          this.mpsMode3 = true;
        }
        if (!this.userInfo.resourceKeys.includes('mpsMode5')) {
          this.displayOption='levelVertical'
        }
      }
    // }
  }
  // 获取国家
  public async getAllAreaCountryList() {
    const { data } = await mpsContractNationalityListApi();
    this.countryOptions = data.data.countryList.filter((v: any) => (v.id !== 34) && (v.id !== 1));
    this.countryOptionsOrg = this.countryOptions;
    this.contractNationalityId = data.data.defaultCountryId;
  }
  public async getSchoolNationalityList() {
    const { data } = await mpsSchoolNationalityListApi();
    this.schoolCountryOptions = data.datas;
  }
  // 获取州省
  public async getByCountryId(id: number) {
    const { data } = await getByCountryIdApi(id);
    this.stateOptions = data.datas;
  }
  // 获取城市
  public async getByFkAreaStateId(id: number) {
    const { data } = await getByFkAreaStateIdApi(id);
    this.cityOptions = data.datas;
  }
  public async getIssueMajorLevelList() {
    const { data } = await getIssueMajorLevelListApi();
    this.fkMajorLevelOptions = data.datas || [];
  }
  public async getMPSInstitutionGroupList() {
    const { data } = await mpsInstitutionGroupDatasApi();
    this.institutionGroupOptions = data.datas;
  }
  public async getMPSInstitutionTypeList() {
    const { data } = await mpsInstitutionTypeDatasApi();
    this.institutionTypeOptions = data.datas;
  }
  public async getMPSInstitutionList() {
    const params = {
      fkAreaCityId: this.cityId !== '' ? this.cityId : null,
      fkAreaCountryId: (this.countryId !== '') && (this.countryId !== "34") ? this.countryId : null,
      fkAreaStateId: this.stateId !== '' ? this.stateId : null,
      fkInstitutionName: this.schoolName !== '' ? this.schoolName : null
    }
    const { data } = await mpsInstitutionListApi(params);
    this.schoolOptions = data.datas;
  }
  public async getSummaryList() {
    const { data } = await mpsTopCountriesDatasApi({fkContractCountryIds: (this.contractNationalityId !== null) ? [this.contractNationalityId] : []});
    this.summaryList = data.datas.slice(0, 4);
  }
  public handleFocusCity() {
    if (this.stateId === '') {
      this.$message.warning({
        message: this.$t('common.focusCityTips') as string,
        offset: 170
      });
      this.showCityTips = true;
    } else {
      this.showCityTips = false;
    }
  }
  public handleFocusState() {
    if (this.countryId === '') {
      this.$message.warning({
        message: this.$t('common.focusProvinceTips') as string,
        offset: 170
      });
      this.showProvinceTips = true;
    } else {
      this.showProvinceTips = false;
    }
  }

  public handleDisplay(val: string) {
    this.isDisableSearchFilter = false;
    if (val !== "general") {
      this.isDisableSearchFilter = true;
    }
    this.displayOption = val;
  }
  public async changeExpand(row: any) {
    row.active = !row.active;
    const { data } = await mpsSaveInstitutionClick(row.id);
  }
  public handleDisplayLevel() {
    this.displayLevel = !this.displayLevel;
  }
  public resetSearch() {
    this.selectCountryId = -100;
    this.initFilter();
    this.getSummaryList();
    this.handleSearch();
  }
  public initFilter() {
    this.schoolName = "";
    this.countryId = "";
    this.stateId = "";
    this.cityId = "";
    this.majorLevel = "";
    this.institutionGroup = "";
    this.schoolTypes = [];
    // this.contractNationalityId = 3;
    this.rule = "";
    this.searchKeyword = "";
    this.stateOptions = [];
    this.cityOptions = [];
    this.schoolOptions = [];
    this.dataPagination = {
      totalSchool: 0,
      totalResult: 0,
      currentPage: 1,
      showCount: 10,
      totalPage: 1
    }
  }
  public handleSelectCountrySpecific(id: number) {
    this.isDisableSearchFilterHot = false;
    if (this.selectCountryId === id) {
      this.selectCountryId = -100;
    } else {
      this.selectCountryId = id;
      if (id === -2 || id === -3 || id === -4) {
        this.initFilter();
        this.isDisableSearchFilterHot = true;
      }
    }
    this.countryOptions = this.countryOptionsOrg.filter((v: any) => (v.id !== this.selectCountryId));
    this.getSummaryList();
    this.handleSearch();
  }
  public handleSelectCountry(item: any, index: number) {
    if (this.selectCountryId === item.id) {
      this.selectCountryId = -100;
      this.selectCountry = "";
      this.countryId = "";
    } else {
      this.selectCountry = item.name;
      this.selectCountryId = item.id;
      this.countryId = item.id;
    }
    this.countryOptions = this.countryOptionsOrg.filter((v: any) => (v.id !== this.selectCountryId));
    this.getSummaryList();
    this.handleSearch();
  }
  // 国家change事件
  public handleChangeCountry(id: number) {
    this.selectCountryId = id;
    this.stateOptions = [];
    this.cityOptions = [];
    this.stateId = "";
    this.cityId = "";
    this.getByCountryId(id);
    //this.getMPSInstitutionList();
    
    this.countryOptions = this.countryOptionsOrg.filter((v: any) => (v.id !== this.selectCountryId));

    this.schoolName = "";
    this.showProvinceTips = false;
    this.getMPSInstitutionList();
    this.getSummaryList();
    this.handleSearch();
  }
  // 州省change事件
  public handleChangeState(id: number) {
    this.cityOptions = [];
    this.cityId = "";
    this.getByFkAreaStateId(id);
    this.schoolName = "";
    this.showCityTips = false;
    this.getMPSInstitutionList();
    this.handleSearch();
  }

  public handleExport() {
    const params = {
      commissionCondition: (this.rule !== '') ? this.rule : null,
      courseLevelIds: (this.majorLevel  !== '') ? [this.majorLevel] : [],
      deputyId: 0,
      fkAgentId: 0,
      fkContractCountryIds: (this.contractNationalityId !== null) ? [this.contractNationalityId] : [],
      fkCountryIds: (this.countryId !== '') ? [this.countryId] : [],
      fkInstitutionAreaCityId: (this.cityId !== '') ? this.cityId : 0,
      fkInstitutionAreaStateId: (this.stateId !== '') ? this.stateId : 0,
      fkInstitutionCountryId: 0,
      fkInstitutionGroupIds: (this.institutionGroup !== '') ? this.institutionGroup : [],
      fkInstitutionId: 0,
      fkInstitutionIds: this.schoolName ? [this.schoolName] : [],
      fkInstitutionTypeIds: this.schoolTypes ? this.schoolTypes : [],
      // fullName : this.schoolName ? this.schoolName : '',
      fullName: '',
      id : 0,
      institutionTabs: null,
      isFollow: undefined,
      hotNum: this.selectCountryId === -2 ? this.searchHot : null,
      newNum: this.selectCountryId === -1 ? this.searchNew : null,
      isCommon: this.selectCountryId === -3 ? true : false,
      isRecommend: this.selectCountryId === -4 ? true : false,
      /*
      isHot: this.selectCountryId === -2 ? true : false,
      isNew: this.selectCountryId === -1 ? true : false,
      */
      keyword: this.searchKeyword ? this.searchKeyword : '',
      mode: 0,
      name: '',
      nameChn: '',
      num: '',
      offerItemId: 0,
      oldFullName: '',
      oldName: '',
      order: 0,
      parentId: 0,
      status: 1
    }
    if (this.displayOption === 'general') {
      this.exportExcel(params);
    }
    if (this.displayOption === 'levelVertical') {
      this.exportLevelExcel(params);
    }
  }
  public exportExcel(params: any) {
    mpsExportExcelApi(params).then((res) => {
      const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8'});
      const navigator: any = window.navigator;
      const nowTime = new Date().toLocaleString();
      const fileName = this.$t('mps.mpsList') + nowTime;
      if (navigator.msSaveOrOpenBlob) { // 兼容IE10
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
        const a = document.createElement('a'); // 创建a标签
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = href; // 指定下载链接
        a.download = fileName + '.xls' // 指定下载文件名
        a.click(); // 触发下载
        URL.revokeObjectURL(a.href); // 释放URL对象
      }
    })
  }
  public exportLevelExcel(params: any) {
    if (this.mpsData && (this.mpsData.length > 0)) {
      mpsLevelExportExcelApi(params).then((res) => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8'});
        const navigator: any = window.navigator;
        const nowTime = new Date().toLocaleString();
        const fileName = this.$t('mps.mpsList') + nowTime;
        if (navigator.msSaveOrOpenBlob) { // 兼容IE10
          navigator.msSaveBlob(blob, fileName);
        } else {
          const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
          const a = document.createElement('a'); // 创建a标签
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = href; // 指定下载链接
          a.download = fileName + '.xls' // 指定下载文件名
          a.click(); // 触发下载
          URL.revokeObjectURL(a.href); // 释放URL对象
        }
      })
    }
  }

  public async handleSearch(dataPagination?: any) {
    this.loading = true;
    let page: any = {};
    if (dataPagination) {
      page = dataPagination
    } else {
      page = {
        all: 0,
        currentPage: 1,
        currentResult: 0,
        showCount: 10,
        totalIssueItem: 0,
        totalPage: 1,
        totalResult: 0,
      }
    }
    const params = {
      ...page,
      data: {
        commissionCondition: (this.rule !== '') ? this.rule : null,
        courseLevelIds: (this.majorLevel  !== '') ? [this.majorLevel] : [],
        deputyId: 0,
        fkAgentId: 0,
        fkContractCountryIds: (this.contractNationalityId !== null) ? [this.contractNationalityId] : [],
        fkCountryIds: (this.countryId !== '') && (Number(this.countryId) !== 34) ? [this.countryId] : [],
        fkInstitutionAreaCityId: (this.cityId !== '') ? this.cityId : 0,
        fkInstitutionAreaStateId: (this.stateId !== '') ? this.stateId : 0,
        fkInstitutionCountryId: 0,
        fkInstitutionGroupIds: (this.institutionGroup !== '') ? this.institutionGroup : [],
        fkInstitutionId: 0,
        fkInstitutionIds: this.schoolName ? [this.schoolName] : [],
        fkInstitutionTypeIds: this.schoolTypes ? this.schoolTypes : [],
        // fullName : this.schoolName ? this.schoolName : '',
        fullName: '',
        id : 0,
        institutionTabs: null,
        isFollow: undefined,
        hotNum: this.selectCountryId === -2 ? this.searchHot : null,
        newNum: this.selectCountryId === -1 ? this.searchNew : null,
        isCommon: this.selectCountryId === -3 ? true : false,
        isRecommend: this.selectCountryId === -4 ? true : false,
        /*
        isHot: this.selectCountryId === -2 ? true : false,
        isNew: this.selectCountryId === -1 ? true : false,
        */
        keyword: this.searchKeyword ? this.searchKeyword : '',
        mode: 0,
        name: '',
        nameChn: '',
        num: '',
        offerItemId: 0,
        oldFullName: '',
        oldName: '',
        order: 0,
        parentId: 0,
        status: 1
      }
    }
    const { data } = await mpsDatasApi(params);
    this.mpsData = [];
    this.dataPagination = {
      totalSchool: 0,
      totalResult: 0,
      currentPage: 1,
      showCount: 10,
      totalPage: 1
    };
    if (Number(this.contractNationalityId) !== Number(this.countryId)) {
      data.datas.forEach((item: any) => {

        this.mpsData.push({
          id: item.id,
          fkAreaCityId: item.fkAreaCityId,
          fkAreaCountryId: item.fkAreaCountryId,
          fkAreaStateId: item.fkAreaStateId,
          areaCountryName: item.areaCountryName,
          areaCountryNameChn: item.areaCountryNameChn,
          institutionTypeName: item.institutionTypeName,
          institutionGroupName: item.institutionGroupName,
          institutionName: item.institutionName,
          name: item.name,
          nameChn: item.nameChn,
          nameDisplay: item.nameDisplay,
          active: false,
          isHot: item.isHot,
          isNew: item.isNew,
          institutionProviderMpsCommissionDetailDtos: item.institutionProviderMpsCommissionDetailDtos,
          institutionProviderMpsLevels: item.institutionProviderMpsLevels
        })
      })
      this.dataPagination = data.page;
      this.dataPagination.totalSchool = data.page.totalResult; // mpsTol佣金条数  totalResult是学校数量
      this.dataPagination.totalResult = data.data.mpsTol;
      if (!data.datas.length && this.selectCountryId === -3) {
        this.$confirm(this.$t('mps.commonNoDataTips') as string, '', {
          confirmButtonText: this.$t('common.confirm') as string,
          showCancelButton: false,
          type: 'info',
        })
      }
    }
    
    this.loading = false;
  }

  public handleCurrentChange(currentPage: number) {
    this.dataPagination.currentPage = currentPage;
    this.handleSearch(this.dataPagination);
  }

  public handleSizeChange(pageSize: number) {
    this.dataPagination.showCount = pageSize;
    this.handleSearch(this.dataPagination);
  }



  public handleSelectAllItem() {
    this.selectAllItem = !this.selectAllItem;
  }

  public handleItemSelected(item: any) {
    this.selectAllItem = true;
    this.mpsData.forEach((mpsItem: any) => {
      if (mpsItem.selected === false) {
        this.selectAllItem = false;
        return;
      }
    })
  }
  
  public changeContractNationalityId(value: any) {
    this.getSummaryList();
  }



}
